export const ITIN_CSS = `
  .si-page {
    background: var(--color-white);
    min-height: 100vh;
  }

  /* ── Hero ── */
  .si-hero {
    position: relative;
    height: 76vh;
    min-height: 360px;
    display: flex;
    align-items: flex-end;
    overflow: hidden;
  }
  .si-hero__bg { position: absolute; inset: 0; }
  .si-hero__bg--zoom img {
    animation: si-kenburns 20s ease-in-out infinite alternate;
  }
  @keyframes si-kenburns {
    from { transform: scale(1); }
    to   { transform: scale(1.06); }
  }
  .si-hero__bg img {
    width: 100%; height: 100%;
    object-fit: cover; display: block;
  }
  .si-hero__bg-fallback {
    width: 100%; height: 100%;
    background: linear-gradient(135deg, var(--color-midnight) 0%, var(--color-navy) 100%);
  }
  .si-hero__overlay {
    position: absolute; inset: 0;
    background: linear-gradient(
      to top,
      rgba(7,30,48,0.72) 0%,
      rgba(7,30,48,0.30) 50%,
      rgba(7,30,48,0.05) 100%
    );
  }
  .si-hero__content {
    position: relative; z-index: 2;
    padding: 0 6vw 48px;
    width: 100%;
    max-width: 1200px;
  }
  .si-hero__eyebrow {
    font-family: var(--font-sans);
    font-size: 10px; font-weight: 500;
    letter-spacing: 0.18em; text-transform: uppercase;
    color: var(--color-gold);
    margin-bottom: 10px;
    display: block;
  }
  .si-hero__title {
    font-size: clamp(2rem, 5vw, 3.6rem);
    color: var(--color-ivory);
    margin: 0 0 16px;
  }
  .si-hero__meta {
    display: flex; flex-wrap: wrap; gap: 20px;
  }
  .si-hero__meta-item {
    display: flex; align-items: center; gap: 7px;
    font-size: 11px; letter-spacing: 0.08em; text-transform: uppercase;
    color: rgba(245,242,236,0.75);
  }
  .si-hero__meta-item svg { color: var(--color-gold); }

  /* ── Main layout ── */
  .si-breadcrumb-wrap {
    padding: 20px 0 0;
    border-bottom: 1px solid var(--color-divider);
    padding-bottom: 16px;
    margin-bottom: 0;
  }
  .si-main {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1.5vw;
  }
  .si-section {
    padding: 32px 0;
    border-bottom: 1px solid var(--color-divider);
  }
  .si-section--last { border-bottom: none; }

  /* ── Highlights ── */
  .si-highlights {
    list-style: none;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0;
  }
  @media (max-width: 600px) { .si-highlights { grid-template-columns: 1fr; } }

  .si-highlight-item {
    display: flex; align-items: baseline; gap: 10px;
    padding: 10px 16px 10px 0;
    font-family: var(--font-sans);
    font-size: 16px;
    color: var(--color-charcoal);
    line-height: 1.5;
  }
  .si-highlight-item:nth-last-child(-n+2) { border-bottom: none; }
  @media (max-width: 600px) {
    .si-highlight-item:last-child { border-bottom: none; }
    .si-highlight-item:nth-last-child(2) { border-bottom: 1px solid var(--color-divider); }
  }
  .si-highlight-item__dot {
    width: 5px; height: 5px; flex-shrink: 0;
    border-radius: 50%;
    background: var(--color-teal);
    margin-top: 6px;
  }

  /* ── Days accordion ── */
  .si-days { display: flex; flex-direction: column; gap: 10px; }

  .si-day-item {
    border: 1px solid var(--color-divider);
    background: var(--color-white);
    transition: border-color 0.22s;
  }
  .si-day-item--open { border-color: var(--color-teal); }

  .si-day-item__header {
    width: 100%; background: none; border: none;
    display: flex; align-items: center; gap: 20px;
    padding: 18px 20px;
    cursor: pointer; text-align: left;
  }
    .si-day-item--open .si-day-item__header{
      background-color: var(--color-teal);
    }
  .si-day-item__label {
    font-size: 10px; font-weight: 500;
    letter-spacing: 0.15em; text-transform: uppercase;
    color: var(--color-gold);
    min-width: 48px; flex-shrink: 0;
  }
  .si-day-item__title {
    font-family: var(--font-serif);
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--color-teal);
    flex: 1;
  }
    .si-day-item--open .si-day-item__title{
      color: var(--color-white);
    }

  .si-day-item__arrow {
    color: var(--color-slate);
    transition: transform 0.28s;
    flex-shrink: 0;
  }
  .si-day-item--open .si-day-item__arrow { transform: rotate(180deg); }

  .si-day-item__body {
    display: grid; grid-template-rows: 0fr;
    transition: grid-template-rows 0.36s ease, padding 0.36s ease;
    padding: 0 20px 0 88px;
  }
  .si-day-item__body > * { overflow: hidden; }
  .si-day-item--open .si-day-item__body {
    grid-template-rows: 1fr;
    padding: 0 20px 24px 88px;
  }

  /* ── Hero cruise link ── */
  .si-hero__meta-cruise {
    text-decoration: none;
    color: rgba(245,242,236,0.75);
    transition: color 0.18s;
  }
  .si-hero__meta-cruise:hover { color: var(--color-gold); }
  .si-hero__meta-cruise svg { color: var(--color-gold); }

  /* ── Prose ── */
  .si-prose {
    font-family: var(--font-sans);
    font-size: 1rem; line-height: 1.85;
    color: var(--color-charcoal);
    margin-top: 1em;
  }
  .si-prose p + p { margin-top: 1.2em; }

  /* ── Cruise Callout ── */
  .si-callout__label {
    display: inline-flex; align-items: center; gap: 6px;
    font-family: var(--font-sans);
    font-size: 10px; font-weight: 500;
    letter-spacing: 0.15em; text-transform: uppercase;
    color: var(--color-gold);
    margin-bottom: 12px;
  }
  .si-callout__label svg { flex-shrink: 0; }
  .si-callout__inner {
    display: flex;
    border: 1px solid var(--color-divider);
    overflow: hidden;
    background: var(--color-white);
    transition: box-shadow 0.25s;
  }
  .si-callout__inner:hover { box-shadow: 0 4px 24px rgba(11,50,80,0.09); }
  @media (max-width: 640px) {
    .si-callout__inner { flex-direction: column; }
  }
  .si-callout__img {
    flex: 0 0 320px;
    min-height: 200px;
    overflow: hidden;
  }
  @media (max-width: 640px) {
    .si-callout__img { flex: none; width: 100%; aspect-ratio: 16 / 9; min-height: unset; }
  }
  .si-callout__img img {
    width: 100%; height: 100%;
    object-fit: cover; display: block;
    transition: transform 0.4s;
  }
  .si-callout__inner:hover .si-callout__img img { transform: scale(1.04); }
  .si-callout__body {
    flex: 1; min-width: 0;
    padding: 28px 32px;
    display: flex; flex-direction: column; justify-content: center; gap: 10px;
  }
  .si-callout__heading {
    display: flex; flex-direction: column; gap: 4px;
  }
  .si-callout__title {
    font-family: var(--font-serif);
    font-size: 1.5rem; font-weight: 400;
    color: var(--color-teal);
    margin: 0;
  }
  .si-callout__title a {
    color: inherit; text-decoration: none;
    transition: color 0.18s;
  }
  .si-callout__title a:hover { color: var(--color-midnight); }
  .si-callout__tagline {
    font-family: var(--font-serif);
    font-style: italic;
    font-size: 0.95rem;
    color: var(--color-slate);
  }
  .si-callout__meta {
    display: flex; flex-wrap: wrap; align-items: center; gap: 8px 16px;
  }
  .si-callout__meta-item {
    display: flex; align-items: center; gap: 6px;
    font-size: 11px; letter-spacing: 0.07em; text-transform: uppercase;
    color: var(--color-slate);
  }
  .si-callout__meta-item svg { color: var(--color-teal); }
  .si-callout__excerpt {
    font-family: var(--font-sans);
    font-size: 0.9rem; line-height: 1.7;
    color: var(--color-slate);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin: 0;
  }
  .si-callout__cta {
    display: inline-flex; align-items: center; gap: 7px;
    margin-top: 4px;
    font-size: 11px; font-weight: 500;
    letter-spacing: 0.1em; text-transform: uppercase;
    color: var(--color-teal);
    text-decoration: none;
    transition: gap 0.2s, color 0.2s;
  }
  .si-callout__cta:hover { gap: 11px; color: var(--color-midnight); }

  /* ── Experiences carousel ── */
  .si-experiences__header {
    display: flex; align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 24px;
  }
  .si-experiences__nav {
    display: flex; gap: 6px;
  }
  .si-experiences__btn {
    width: 36px; height: 36px;
    display: flex; align-items: center; justify-content: center;
    background: var(--color-white);
    border: 1px solid var(--color-divider);
    color: var(--color-charcoal);
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s, color 0.2s;
  }
  .si-experiences__btn:hover:not(:disabled) {
    background: var(--color-teal);
    border-color: var(--color-teal);
    color: white;
  }
  .si-experiences__btn:disabled { opacity: 0.3; cursor: default; }

  .si-experiences__track-wrap { overflow: hidden; }
  .si-experiences__track {
    display: flex; gap: 10px;
    transition: transform 0.38s cubic-bezier(0.4,0,0.2,1);
  }

  .si-experience-card { flex: 0 0 calc((100% - 10px) / 2); min-width: 0; }
  @media (min-width: 640px) {
    .si-experience-card { flex: 0 0 calc((100% - 20px) / 3); }
  }
  @media (min-width: 1024px) {
    .si-experience-card { flex: 0 0 calc((100% - 30px) / 4); }
  }
  .si-experience-card--clickable { cursor: zoom-in; }
  .si-experience-card__img {
    aspect-ratio: 4 / 3;
    overflow: hidden;
    margin-bottom: 10px;
  }
  .si-experience-card__img img {
    width: 100%; height: 100%;
    object-fit: cover; display: block;
    transition: transform 0.4s;
  }
  .si-experience-card:hover .si-experience-card__img img { transform: scale(1.05); }
  .si-experience-card__title {
    font-family: var(--font-sans);
    font-size: 12px; font-weight: 500;
    letter-spacing: 0.04em;
    color: var(--color-charcoal);
  }

  /* ── Inclusions / Exclusions ── */
  .si-inc-exc {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }
  @media (max-width: 640px) { .si-inc-exc { grid-template-columns: 1fr; gap: 32px; } }

  .si-inc-exc__heading {
    font-family: var(--font-sans);
    font-size: 11px; font-weight: 500;
    letter-spacing: 0.1em; text-transform: uppercase;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 2px solid;
  }
  .si-inc-exc__heading--inc { color: var(--color-teal); border-color: var(--color-teal); }
  .si-inc-exc__heading--exc { color: var(--color-slate); border-color: var(--color-divider); }

  .si-inc-exc__list { list-style: none; display: flex; flex-direction: column; gap: 10px; }

  .si-inc-exc__item {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 0.95rem; line-height: 1.55;
    color: var(--color-charcoal);
  }
  .si-inc-exc__item svg { flex-shrink: 0; margin-top: 1px; }
  .si-inc-exc__item--inc > svg { color: var(--color-teal); }
  .si-inc-exc__item--exc > svg { color: var(--color-gold); opacity: 0.5; }

  .si-inc-exc__sublist {
    list-style: none;
    display: flex; flex-direction: column; gap: 6px;
    margin-top: 8px;
  }
  .si-inc-exc__subitem {
    display: flex; align-items: flex-start; gap: 7px;
    font-size: 0.9rem; line-height: 1.5;
    color: var(--color-slate);
  }
  .si-inc-exc__subitem svg { flex-shrink: 0; margin-top: 3px; opacity: 0.6; }

  /* ── Notes ── */
  .si-notes__header {
    display: flex; align-items: center; gap: 10px;
    margin-bottom: 8px;
    color: var(--color-teal);
  }
  .si-notes__body {
    background: var(--color-off-white);
    border-left: 3px solid var(--color-teal);
    padding: 20px 24px;
    font-size: 0.95rem;
    color: var(--color-slate);
  }
    .si-notes__body ol{margin-left: 15px;}
    .si-notes__body ul{margin-left: 20px;}
`
